
import React, { useEffect, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import Loader from "../common/Spinner";
import godrejDarkLogo from "../../assets/images/godrej.svg"
import loginBgImage from "../../assets/images/Legal_Login_Image.svg"
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";

const LoginPage = (props) => {

    const { instance } = useMsal();
    const loading = false;

    let err = ""
    const [errorMessage, setErrorMessage] = useState(err ? err : "");

    const loginFunction = async () => {
        setErrorMessage("");
        console.log("loginRequest ==> ", loginRequest);
        instance.loginRedirect(loginRequest).catch(e => {
            console.log("error in login", e)
        });
    };

    useEffect(() => {
        setErrorMessage(props.loginErrorMessage);
        if (props.loginErrorMessage) {
            sessionStorage.clear();
        }
    }, [props.loginErrorMessage]);

    return (
        <>
            {loading && <Loader />}
            <div className="d-flex logoHeader">
                <img src={godrejDarkLogo} alt="GodrejEntLogo" />
                <span className="headerLink">Godrej Enterprises Group</span>
            </div>
            <div className="login-container">
                <Row className="pb-0">
                    <Col xs={12} md={8} className="d-none d-md-block d-lg-block">
                        <img src={loginBgImage} alt="Login Background" style={{
                            width: '100%',
                            height: '100vh',
                            objectFit: 'cover'
                        }} />
                    </Col>
                    <Col xs={12} md={4}>
                        <div className="loginForm">
                            <div className="login-logo text-start mb-4">
                                <h1>Commercial Legal Website</h1>
                            </div>
                            <div className="mt-3 mb-3">
                                {errorMessage && (
                                    <div className="loginErrorDiv">
                                        <div className="loginErrorDivHeader">Login Failed</div>
                                        <div className="loginErrorDivBody">{errorMessage}</div>
                                    </div>
                                )}
                            </div>
                            <div>
                                <div className="mt-4">
                                    <Button variant="success"
                                        onClick={async () => {
                                            await loginFunction();
                                        }}
                                        className="loginButton">
                                        Login
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default LoginPage;